<template>
  <div class="display row">
    <div class="renewal-notice col-12">
      <p>
        Rhythm Readerは、リズム電卓としてリニューアルしました。
        <a :href="renewalUrl">新「リズム電卓」へ</a>
      </p>
    </div>
    <canvasbox
      v-for="num in canvasNum"
      :score="score"
      :boxnum="num"
      :key="num"></canvasbox>
  </div>
</template>

<script>
import canvasbox from './canvasbox.vue'
import {generateURLparam} from '../../url_trans/url_transffer'

export default {
  name: 'display',
  components: {
    canvasbox
  },
  props: {
  },
  computed: {
    canvasNum: function(){
      return this.$store.getters.boxNum;
    },
    score: function(){
      return this.$store.state.score;
    },
    renewalUrl: function(){
      const rm = generateURLparam(this.$store.state.score);
      const tp = this.$store.state.tempo;
      return 'https://rhythm-calculator.colour-field.jp/ja/app?tp=' + tp + '&rm=' + rm;
    }
  },
  watch: {
    canvasNum: function(new_val, old_val){
      if (new_val >= old_val){
        this.$nextTick(() => {
          window.scrollTo({
            left: 0,
            top: document.body.scrollHeight || document.documentElement.scrollHeight,
            behavior: "smooth"
          });
        });
      }
    }
  }
}
</script>

<style scoped>
.display{
  overflow-y: hidden;
  overflow-x: hidden;
}

.renewal-notice{
  padding: 0.75rem 10px 1rem;
  font-family: 'Sawarabi Gothic', sans-serif;
}

.renewal-notice p{
  margin: 0 auto;
  padding: 0.6rem 1rem;
  color: #21324d;
  background: #fff7df;
  border: 1px solid #e5cf8f;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
}

.renewal-notice a{
  display: inline-block;
  color: #233b67;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: 700;
}
</style>
